import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=32d0a5a2&scoped=true"
import script from "./Countdown.js?vue&type=script&lang=js&external"
export * from "./Countdown.js?vue&type=script&lang=js&external"
import style0 from "./Countdown.scss?vue&type=style&index=0&id=32d0a5a2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0a5a2",
  null
  
)

export default component.exports